<template>
  <transition name="gr-cookie-fade">
    <div v-if="visible" class="gr-cookie-banner" role="dialog" aria-live="polite">
      <div class="gr-cookie-inner">
        <div class="gr-cookie-text">
          <v-icon class="gr-cookie-icon">mdi-cookie-outline</v-icon>
          <p class="mb-0">
            {{ t.texto }}
            <router-link :to="politicaCookiesTo" class="gr-cookie-link">{{ t.masInfo }}</router-link>
          </p>
        </div>

        <div class="gr-cookie-actions">
          <v-btn text small class="gr-cookie-reject" @click="decidir(false)">
            {{ t.rechazar }}
          </v-btn>
          <v-btn small depressed class="gr-cookie-accept" @click="decidir(true)">
            {{ t.aceptar }}
          </v-btn>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  /* La decision del usuario no solo se guarda: activa o desactiva de verdad
     los scripts de terceros. Toda esa logica vive en un unico sitio,
     src/plugins/consentimiento.js, para que nadie pueda cargar Google o
     Microsoft por otra puerta. */
  import consentimiento from '@/plugins/consentimiento';

  export default {
    name: 'CookieBanner',

    data: () => ({
      visible: false,
    }),

    computed: {
      esCat() {
        return (this.$route && this.$route.path || '').endsWith('cat');
      },
      politicaCookiesTo() {
        return this.esCat ? '/politica-cookies-cat' : '/politica-cookies-esp';
      },
      t() {
        return this.esCat ? this.textos.cat : this.textos.es;
      },
      textos() {
        return {
          es: {
            texto: 'Usamos cookies propias y de terceros para el funcionamiento de la web y analizar su uso. Puedes aceptarlas o rechazarlas.',
            masInfo: 'Más información',
            aceptar: 'Aceptar',
            rechazar: 'Rechazar',
          },
          cat: {
            texto: 'Utilitzem galetes pròpies i de tercers per al funcionament del web i analitzar-ne l\'ús. Pots acceptar-les o rebutjar-les.',
            masInfo: 'Més informació',
            aceptar: 'Acceptar',
            rechazar: 'Rebutjar',
          },
        };
      },
    },

    mounted() {
      // Si ya acepto en una visita anterior, cargamos la analitica sin
      // volver a preguntar. Si rechazo, o si todavia no ha decidido, no se
      // carga nada: el silencio nunca cuenta como un si.
      const decision = consentimiento.leer();

      if (decision === 'accepted') {
        consentimiento.aplicarSiYaDecidido();
      } else if (decision !== 'rejected') {
        this.visible = true;
      }
    },

    methods: {
      decidir(aceptado) {
        // Guarda la decision y, segun cual sea, carga los scripts o borra las
        // cookies que hubieran quedado de una aceptacion anterior.
        consentimiento.aplicar(aceptado);
        this.visible = false;
      },
    },
  };
</script>

<style scoped>
  .gr-cookie-banner {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
    background: #37454A;
    color: #fff;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.25);
  }

  .gr-cookie-inner {
    max-width: 1100px;
    margin: 0 auto;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .gr-cookie-text {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1 320px;
    font-size: 0.88rem;
    line-height: 1.4;
  }

  .gr-cookie-icon {
    color: #fff;
    opacity: 0.9;
  }

  .gr-cookie-link {
    color: #fff;
    text-decoration: underline;
    font-weight: 600;
    white-space: nowrap;
  }

  .gr-cookie-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 0 0 auto;
  }

  .gr-cookie-reject {
    color: #fff !important;
  }

  .gr-cookie-accept {
    background: #900A30 !important;
    color: #fff !important;
    font-weight: 700;
  }

  @media (max-width: 600px) {
    .gr-cookie-inner {
      justify-content: center;
    }
    .gr-cookie-actions {
      width: 100%;
      justify-content: center;
      margin-top: 4px;
    }
  }

  .gr-cookie-fade-enter-active,
  .gr-cookie-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  .gr-cookie-fade-enter,
  .gr-cookie-fade-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }
</style>
